import FormControlLabel from '@mui/material/FormControlLabel';
import type { FormControlLabelProps } from '@mui/material/FormControlLabel';
import type { ChangeEvent, FunctionComponent, ReactNode } from 'react';

import Radio from './Radio';

type LabeledRadioProps = {
  label: ReactNode;
  value: string;
  isDisabled?: boolean;
  labelPlacement?: FormControlLabelProps['labelPlacement'];
  isRippleDisabled?: boolean;
  isChecked?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>, value: string) => void;
};

/**
 * Wrapper for MaterialUI's <FormControlLabel /> + <Radio />
 * More aligned with the old RadioButton component API.
 * Should be used inside of a MUI.RadioGroup (which has an onChange handler)
 */
const LabeledRadio: FunctionComponent<LabeledRadioProps> = ({
  label,
  value,
  isDisabled,
  labelPlacement = 'end',
  isRippleDisabled,
  isChecked,
  onChange,
}) => (
  <FormControlLabel
    label={label}
    labelPlacement={labelPlacement}
    value={value}
    disabled={isDisabled}
    control={
      <Radio
        value={value}
        isChecked={isChecked}
        isDisabled={isDisabled}
        isRippleDisabled={isRippleDisabled}
        onChange={onChange}
      />
    }
  />
);

export default LabeledRadio;
